import { DepressionContentPage } from "@/components/DepressionContentPage";

const CollegeStudentDepressionTreatment = () => (
  <DepressionContentPage
    seo={{
      title:
        "College Student Depression Treatment | Neuro Wellness TMS Centers of America",
      description:
        "When a college student is struggling with depression, treatment options and scheduling matter. Learn how families and students can explore advanced treatment options.",
      canonical: "/college-student-depression-treatment",
      keywords:
        "college student depression, depression treatment young adult, student mental health treatment, Coral Springs, school break treatment",
    }}
    badge="For Students & Families"
    heroTitle="When a College Student Is Struggling With Depression"
    heroSubtitle="College brings new pressures — academic demands, changing routines, and separation from familiar support. When a student is struggling with depression, both the student and the family often have questions about what comes next."
    sections={[
      {
        heading: "What Depression Can Look Like in College",
        variant: "text",
        body: (
          <p>
            Depression in college students can show up as declining academic
            performance, withdrawal from friends, difficulty functioning, and
            disrupted sleep or routine. Sometimes it's mistaken for laziness or
            homesickness. It is neither. Depression is a treatable condition,
            and recognizing it is the first step.
          </p>
        ),
      },
      {
        heading: "If You're the Student",
        variant: "text",
        body: (
          <p>
            If you're reading this for yourself, you've already taken an
            important step. You don't need to have everything figured out. If
            you've tried medication or therapy and are still struggling, there
            are other options worth understanding. A consultation is a
            conversation — no pressure, no commitment.
          </p>
        ),
      },
      {
        heading: "If You're the Parent",
        variant: "text",
        body: (
          <p>
            If you're researching on behalf of your college-aged child, you can
            learn about treatment options and the consultation process. Your
            child must be the one to consent to and participate in treatment,
            but gathering information is something you can do now.
          </p>
        ),
      },
      {
        heading: "Treatment Options Worth Understanding",
        variant: "text",
        body: (
          <p>
            When standard treatments haven't provided enough relief,
            interventional approaches like TMS, accelerated TMS, SAINT®, and
            SPRAVATO® may be worth exploring. Each works through a different
            mechanism than oral medication. Whether any is appropriate is a
            clinical determination.
          </p>
        ),
      },
      {
        heading: "Scheduling Considerations",
        variant: "text",
        body: (
          <p>
            Treatment scheduling matters for students. Traditional TMS involves
            sessions over several weeks. Accelerated protocols like SAINT®
            compress treatment into five consecutive days. Some families
            coordinate treatment during school breaks or semester transitions.
          </p>
        ),
      },
      {
        heading: "Family Involvement & Privacy",
        variant: "text",
        body: (
          <p>
            Family support matters, and so does the student's privacy. With the
            patient's consent, family members may participate in consultations.
            Clinical details require the patient's consent. We respect both the
            student's autonomy and the family's concern.
          </p>
        ),
      },
    ]}
    faq={[
      {
        question:
          "Can a parent call about treatment for their college student?",
        answer:
          "Yes. A parent can contact us to learn general information about services and the consultation process. The student must consent to and participate in treatment.",
      },
      {
        question: "Can treatment be scheduled during school breaks?",
        answer:
          "Yes. Some families coordinate treatment during winter break, summer, or semester transitions. Accelerated protocols like SAINT®, which take five days, can fit into a break. We can discuss scheduling options during your consultation.",
      },
      {
        question: "Will my college know I'm receiving treatment?",
        answer:
          "Your treatment is private. We do not share clinical information with your school without your consent. If you need documentation for academic accommodations, that is handled separately and with your permission.",
      },
    ]}
    relatedLinks={[
      {
        title: "Helping Someone You Love With Depression",
        href: "/helping-someone-with-depression",
      },
      {
        title: "My Adult Child Has Depression",
        href: "/adult-child-with-depression",
      },
      {
        title: "Depression Treatment Options",
        href: "/depression-treatment-options",
      },
      {
        title: "What Happens During a Consultation",
        href: "/depression-treatment-consultation",
      },
    ]}
    finalCtaText="Whether you're a student or a parent, you don't have to figure this out alone. Call our team to understand what options may be available."
  />
);

export default CollegeStudentDepressionTreatment;
